import { RxDocument } from 'rxdb'
import { set } from '@cicero/data/utils'
import { Attr, BaseSchema, ModelSchema } from './helpers'
import { AttributeSchema } from './AttributeSchema'
import { PageInboxStatus } from './PageSchema'

@ModelSchema({
  name: 'attribute_option',
  description: 'An option is one possible typed value of an attribute',
  version: 0,
  required: ['attribute_id'],
  indexes: ['order'],
  associations: () => [
    { type: 'belongsTo', model: AttributeSchema, key: 'attribute', foreignKey: 'attribute_id' },
  ],
  lifecycle: {
    transformQuery(query) {
      query = BaseSchema.LIFECYCLE.transformQuery(query)
      if (!query.sort) { set(query, 'sort', [{ order: 'asc' }]) } // Always sort by order by default
      return query
    },
  },
})
export class AttributeOptionSchema extends BaseSchema {
  @Attr({ type: 'string', required: true }) value: string
  @Attr({ type: 'string', required: true }) color: string
  @Attr({ type: 'number', required: true }) order: number
  @Attr({ type: 'number' }) inbox_status?: PageInboxStatus

  attribute_id: string
}

export type AttributeOptionDoc = RxDocument<AttributeOptionSchema>
